(function(){
  if(window.__famigo)return;window.__famigo=1;
  function ready(fn){document.readyState!=='loading'?fn():document.addEventListener('DOMContentLoaded',fn)}
  ready(function(){
    // Scroll reveal
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('fam-in');io.unobserve(e.target)}})},{threshold:.12});
    document.querySelectorAll('.fam-reveal').forEach(function(el){io.observe(el)});
    // Rotating word
    document.querySelectorAll('[data-fam-rotate]').forEach(function(rot){
      var words=rot.getAttribute('data-fam-rotate').split(',').map(function(w){return w.trim()}).filter(Boolean);
      if(words.length<2)return;var i=0;
      setInterval(function(){rot.style.opacity=0;rot.style.transform='translateY(14px)';
        setTimeout(function(){i=(i+1)%words.length;rot.textContent=words[i];rot.style.opacity=1;rot.style.transform='translateY(0)'},400)},2800);
    });
    // Toast
    var toast=document.createElement('div');toast.className='fam-toast';document.body.appendChild(toast);
    window.famToast=function(msg){toast.textContent=msg;toast.classList.add('show');setTimeout(function(){toast.classList.remove('show')},2600)};
    // Quick add (AJAX)
    document.addEventListener('submit',function(e){
      var f=e.target.closest('.fam-qa-form');if(!f)return;e.preventDefault();
      var btn=f.querySelector('.fam-qa');var old=btn.textContent;btn.textContent='Adding…';
      fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/add.js',{method:'POST',body:new FormData(f)})
        .then(function(r){if(!r.ok)throw 0;return r.json()})
        .then(function(){famToast('Added to cart ✓');document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));})
        .catch(function(){famToast('Could not add — please try the product page')})
        .finally(function(){btn.textContent=old});
    });
  });
})();
